import React from 'react';
import {catalog} from '../db.js';
import {Link} from "react-router-dom";

export default class TattooDes extends React.Component{
	constructor(props){
		super(props);
		this.state={
			photoCount: 0
		};
		this.slide=this.slide.bind(this);
	}
	slide(e){
		const a = e.currentTarget.getAttribute('data-count');
		this.setState({photoCount:a});
	}
	render(){
		const a = +this.props.match.params.id;
		const tattoo= catalog[a-1];
		return(
			<div className='tattoodes'>
				<div className='img anime'>
					<img src={require('../../img/db/'+tattoo.photo[this.state.photoCount])}/>
					<div className='master'>{tattoo.master}</div>
				</div>
				<ul className='img-list'>
					{
						tattoo.photo.map((i,n) =>(
							<li className='anime' data-count={n} onClick={this.slide} key={n}>
								<img src={require('../../img/db/'+i)}/>
							</li>
						))
					}
					<Link to='/works'>back</Link>
				</ul>
			</div>
		)
	}
}